module.exports = __webpack_public_path__ + "static/backgroundcourses-21-fcf1468c96fbb010a30198ada005d02c.png";